import { useEffect } from 'react';

function useFocusOnEnter(inputRef, visible, enterDuration) {
  useEffect(() => {
    const input = inputRef.current;
    if (visible && input) {
      // Wait until the searchbar has been fully opened before focussing the
      // input in order to avoid positioning glitches on iOS when opening the
      // keyboard
      setTimeout(() => {
        input.focus();
      }, enterDuration);
    }
  }, [inputRef, visible, enterDuration]);
}

export { useFocusOnEnter };
//# sourceMappingURL=hook.focus-on-enter.js.map
